import React from 'react'
import { useFormik } from 'formik'

// components
import InputField from '../../../components/forms/InputField/InputField.component';

// mui
import { Button } from '@mui/material';

export default function LoginForm({ handleSubmit, errors = {} }) {

    const formik = useFormik({
        initialValues: {
            username: '',
            password: ''
        },
        onSubmit: values => {
            handleSubmit(values)
        },
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <div>
                <InputField
                    id="username"
                    placeholder="Username"
                    type="text"
                    onChange={formik.handleChange}
                    value={formik.values.username}
                    showRequired={false}
                    isValid={errors['username']}
                />
            </div>

            <div>
                <InputField
                    id="password"
                    placeholder="Password"
                    type="password"
                    onChange={formik.handleChange}
                    value={formik.values.password}
                    showRequired={false}
                    isValid={errors['password']}
                />
            </div>
            
            <Button type='submit' color='success' variant='contained'>Login</Button>
        </form>
    )
}